import React, { useEffect } from 'react';
import { FileText } from 'react-feather';
import { useHistory } from 'react-router-dom';
import routes from './../../routes';

function Reports() {
  const history = useHistory();

  // Set overflow to hidden on mount and restore on unmount
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  // Example report data (placeholder)
  const summaries = [
    { label: 'Invoices', value: 125, color: '#3b82f6', route: routes.invoices },
    { label: 'Commissions', value: 58, color: '#10b981', route: routes.commissionsreports },
    { label: 'Renewals', value: 72, color: '#f59e0b', route: routes.renewalsreports },
  ];

  const handleCardClick = (route) => {
    history.push(route);
  };

  return (
    <div className="bg-light min-vh-100 d-flex flex-column">
      {/* Header */}
      <div className="bg-white container">
        <div className="container py-4">
          <h1 className="h3 font-weight-bold text-dark">Reports</h1>
          <p className="text-muted mb-0">Invoices, Commissions, and Renewals overview.</p>
        </div>
      </div>
       
      <div className="container py-3 flex-grow-1 d-flex align-items-center justify-content-center">
        {/* Centered Summary Cards */}
        <div className="row row-cols-1 row-cols-md-3 g-4 w-100 justify-content-center">
          {summaries.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-5 col-sm-7">
              <div
                className="card h-100 shadow-sm border-0 cursor-pointer position-relative"
                onClick={() => handleCardClick(item.route)}
                style={{ cursor: 'pointer', transition: 'transform 0.2s', borderRadius: '15px' }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
              >
                <div className="card-body d-flex align-items-center justify-content-between p-4">
                  <div>
                    <h6 className="card-subtitle mb-2 text-muted">{item.label}</h6>
                    <h5 className="card-title font-weight-bold text-dark h1">{item.value}</h5>
                    <small className="text-primary font-weight-bold">Click here to view details</small>
                  </div>
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{ backgroundColor: item.color, width: '80px', height: '80px' }}
                  >
                    <FileText className="text-white" size={40} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Reports;